import { renderPage } from "renderPage"
import { ClubPlanShowPage } from "./Page"

renderPage({ component: ClubPlanShowPage })
